













































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import SelectArea from '@/components/common/modules/SelectArea.vue';
import SigninModel from '@/models/signinModel';
import authState from '@/store/auth';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
import appState from '@/store/app';

interface MyComponent extends Vue {
  prev: Route;
}

@Component({
  components: { SelectArea },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      (vm as MyComponent).prev = from;
    });
  }
})
export default class Signin extends Vue {
  private signinModel = new SigninModel();
  private token = '';
  private email = '';
  private password = '';
  private errorMess = '';
  private show1 = false;
  private selectValue = '';
  private selectData = {
    label: '',
    name: 'select',
    disabled: false,
    options: [{ value: '', text: '' }]
  };
  private selectValueApplication = '';
  private selectDataApplication = {
    label: '',
    name: 'select',
    disabled: false,
    options: [{ value: '', text: '' }]
  };
  private workspaces: Array<{ [k: string]: string }> = [];
  private applications: Array<{
    application_id: string;
    name: string;
    display_id: string;
    datastores: Array<{
      datastore_id: string;
      name: string;
    }>;
  }> = [];
  private prev!: Route;

  mounted(){
    if (this.prev.name !== null && this.prev.name === 'ResetPassword') {
      this.errorMess = '再度サインインしてください。'
    }
  }

  private async signin() {
    this.errorMess = '';
    try {
      // this.$store.commit('common/setLoading', true);
      // Authトークンの取得
      this.token = await this.signinModel.login(this.email, this.password);
      // 認証トークンをセット
      authState.setToken(this.token);
      // Hexalink UserInfoの取得
      const userInfo = await this.signinModel.getUserInfo();
      // ユーザ名をセット
      userState.setUserName(userInfo.username);
      // メールアドレスをセット
      userState.setUserEmail(userInfo.email);
      // ユーザーのロール権限がsystem_administratorか否か
      if (
        userInfo.user_roles.find(
          (roles: { [k: string]: string }) => roles.role_id === 'system_administrator'
        ) !== undefined
      ) {
        userState.setIsAdmin(true);
      }
      // ユーザーのロール権限がuser_administratorか否か
      if (
        userInfo.user_roles.find(
          (roles: { [k: string]: string }) => roles.role_id === 'user_administrator'
        ) !== undefined
      ) {
        userState.setIsUserAdmin(true);
      }
      // ユーザーのロール権限がsales_managerか否か
      if (
        userInfo.user_roles.find(
          (roles: { [k: string]: string }) => roles.role_id === 'sales_manager'
        ) !== undefined
      ) {
        userState.setIsSalesManager(true);
      }
      // workspaceの取得
      // セレクトエリア表示データ
      this.workspaces = await this.signinModel.getWorkspaces();
      // ワークスペースが1つだけだった場合、アプリケーション選択へ遷移
      // if (this.workspaces.length === 1) {
      //   this.selectValue = this.workspaces[0].workspace_id;
      //   this.selectWorkspace();
      // } else {
      //   // セレクトエリア表示データ
      //   for (const key in this.workspaces) {
      //     this.selectData.options.push({
      //       value: this.workspaces[key].workspace_id,
      //       text: this.workspaces[key].workspace_name
      //     });
      //   }
      // }

      this.$router.push({ name: 'UploadFileScreen' });
      hexabaseState.setApplicationId("67c18a5945483f4f53e982ab");
      // HexabasedatastoreIds（データストア一覧）をセット
      hexabaseState.setDatastoreIds({
        csv_database: "67c57ff80dde78a507f3dbcb"
      });
    } catch (e) {
      this.errorMess = e.message;
    } finally {
      // this.$store.commit('common/setLoading', false);
    }
  }

  private async selectWorkspace() {
    try {
      this.errorMess = '';
      // HexabaseワークスペースIDをセット
      hexabaseState.setWorkspaceId(this.selectValue);
      // applicationの取得
      this.applications = await this.signinModel.getApplications();
      // アプリケーションが1つだけだった場合、TOP画面へそのまま遷移する
      if (this.applications.length === 1) {
        this.selectValueApplication = this.applications[0].application_id;
        this.selectApplication();
      } else {
        // セレクトエリア表示データ
        for (const key in this.applications) {
          this.selectDataApplication.options.push({
            value: this.applications[key].application_id,
            text: this.applications[key].name
          });
        }
      }
    } catch (e) {
      this.errorMess = 'アプリケーションの取得でエラーが発生しました。';
    }
  }

  private selectApplication() {
    this.errorMess = '';
    this.initialSignin();
  }

  private async initialSignin() {
    try {
      const app = this.applications.find(v => v.application_id === this.selectValueApplication);
      if (app === undefined) {
        this.errorMess = '有効なアプリケーションが取得できません。';
        return;
      }

      const applicationId = app?.application_id;
      const datastores = app?.datastores;

      const datastoreIds: any = {};
      if (datastores)
        datastores.forEach((datastore: any) => {
          datastoreIds[datastore.name] = datastore.datastore_id;
        });

      // HexabaseアプリケーションIDをセット
      hexabaseState.setApplicationId(applicationId);
      // HexabasedatastoreIds（データストア一覧）をセット
      hexabaseState.setDatastoreIds(datastoreIds);
      // メールアドレスをキーとして社員マスタの自身のレコードを取得

      const params = {
        conditions: [
          {
            id: 'activated_email_address',
            search_value: [userState.userEmail],
            exact_match: true
          }
        ],
        per_page: 1,
        page: 1,
        use_display_id: true,
        include_lookups: true
      };
      const userEmployeeInfo = await this.signinModel.getItemList(
        hexabaseState.applicationId,
        hexabaseState.datastoreIds['社員マスタ'],
        params
      );

      if (userEmployeeInfo.length > 0) {
        userState.setUserEmployeeId(userEmployeeInfo[0].i_id ? userEmployeeInfo[0].i_id : '');
        userState.setMatterBranchKey(
          userEmployeeInfo[0].lookup_items.company_id.matter_number_prefix
            ? userEmployeeInfo[0].lookup_items.company_id.matter_number_prefix
            : ''
        );
        userState.setEstimateBranchKey(
          userEmployeeInfo[0].lookup_items.company_id.estimate_number_prefix
            ? userEmployeeInfo[0].lookup_items.company_id.estimate_number_prefix
            : ''
        );
        userState.setUserDepartmentName(
          userEmployeeInfo[0].lookup_items.group_relation.group_name
            ? userEmployeeInfo[0].lookup_items.group_relation.group_name
            : '-'
        );
        userState.setUserDepartmentId(
          userEmployeeInfo[0].lookup_items.group_relation.group_id
            ? userEmployeeInfo[0].lookup_items.group_relation.group_id
            : ''
        );
        userState.setCustomerBranchKey(
          userEmployeeInfo[0].lookup_items.company_id.customer_number_prefix
            ? userEmployeeInfo[0].lookup_items.company_id.customer_number_prefix
            : ''
        );
        userState.setDigit(
          userEmployeeInfo[0].lookup_items.company_id.digit
            ? userEmployeeInfo[0].lookup_items.company_id.digit
            : 5
        );
        userState.setIsEstimateNumberManualEntry(
          userEmployeeInfo[0].lookup_items.company_id.estimate_number_manual_entry_flag
            ? JSON.parse(
                userEmployeeInfo[0].lookup_items.company_id.estimate_number_manual_entry_flag.toLowerCase()
              )
            : false
        );
        userState.setUserEmployeeName(userEmployeeInfo[0].name ? userEmployeeInfo[0].name : '-');
      }

      // 管理マスタの定数群取得
      if ('管理マスタ' in datastoreIds) {
        const optionList = await this.signinModel.getApplicationOptions(applicationId, datastoreIds['管理マスタ']);
        appState.setOptions(optionList);
      }

      // ログイン後画面に遷移
      this.$router.push({ name: 'Portal' });
    } catch (e) {
      console.log(e)
      this.errorMess = 'エラーが発生しました。';
    } finally {
      // this.$store.commit('common/setLoading', false);
    }
  }

  private catchInput(response: any): void {
    this.selectValue = response.value;
  }

  private catchInputApplication(response: any): void {
    this.selectValueApplication = response.value;
  }
}
